module.exports = __webpack_public_path__ + "img/ionic-logo.90aa8d48.png";